import toEchartData from './dataProcessor';
import { wrapWithMaxWidth } from '../../tooltipUtils';

function tooltipFormatter(params) {
  const meta = params.data[5];
  if (!meta || !meta.resposta) return params.data.name || '';
  const { pergunta, alternativa } = meta.resposta;
  const content = `<strong>${pergunta.enunciado}</strong><br/><i>${alternativa.enunciado}</i>: ${meta.correlacao}`;
  return wrapWithMaxWidth(content, 300);
}

/**
 * Constrói o echart option do bubble simples de correlação no contrato consumido pelo
 * ChartManager.
 *
 * Cada pergunta correlacionada vira uma série de scatter independente. Isso alinha
 * `option.color[seriesIndex]` à pergunta (mesma convenção do graph_bubble/treemap),
 * permite que a legenda renderize cada pergunta com sua própria cor sem hack, e
 * deixa o color picker e o highlit usarem o pipeline padrão do ChartManager.
 *
 * @param {object} data Dado bruto da correlação
 * @param {{colors: string[], highlitedItemBorderType?, highlitedItemBorderColor?, highlitedItemBorderWidth?, legend?}} colors Tema parsado
 * @param {number} fontSize Tamanho de fonte (legend / axis)
 * @param {Array<string>} _disabledLegends (não usado aqui — a visibilidade é controlada pela legenda nativa do echarts)
 * @param {number} highlitIndex Índice da pergunta highlightada
 */
export default function toSimpleBubbleEchartOption(data, colors, fontSize, _disabledLegends, highlitIndex) {
  const { perguntas, seriesByPergunta } = toEchartData(data);
  const themeColors = (colors && colors.colors) || [];

  const legendTheme = (colors && colors.legend) || {};
  const legendPagination = legendTheme.pagination || {};

  const highlitStyle = (typeof highlitIndex === 'number' && highlitIndex >= 0)
    ? {
      borderType: colors && colors.highlitedItemBorderType,
      borderColor: colors && colors.highlitedItemBorderColor,
      borderWidth: colors && colors.highlitedItemBorderWidth,
    }
    : null;

  const series = seriesByPergunta.map(({ name, bubbles }, idx) => ({
    name,
    type: 'scatter',
    data: bubbles,
    symbolSize: (dat) => Math.sqrt(dat[2]),
    ...(highlitStyle && idx === highlitIndex ? { itemStyle: highlitStyle } : {}),
  }));

  return {
    color: themeColors,
    // `legend.data` carrega a lista canônica de perguntas correlacionadas — mesma
    // convenção consumida pelo treemap e pelo graph_bubble. Como cada série tem
    // `name === perguntaEnunciado` e `option.color[i]` está alinhado a essa lista,
    // o echarts deriva a cor de cada chip a partir da série correspondente.
    legend: {
      data: perguntas,
      top: 0,
      left: 'center',
      type: 'scroll',
      textStyle: {
        color: legendTheme.color,
        fontSize,
      },
      pageTextStyle: {
        color: legendPagination.text && legendPagination.text.color,
      },
      pageIconColor: legendPagination.buttons && legendPagination.buttons.color,
    },
    xAxis: {
      splitLine: {
        lineStyle: {
          type: 'dashed',
        },
      },
      show: false,
    },
    yAxis: {
      splitLine: {
        lineStyle: {
          type: 'dashed',
        },
      },
      axisLabel: {
        textStyle: {
          fontSize,
        },
      },
      scale: true,
    },
    tooltip: {
      formatter: tooltipFormatter,
      confine: true,
    },
    series,
  };
}
